import { render, staticRenderFns } from "./IftaView.vue?vue&type=template&id=689a3164"
import script from "./IftaView.vue?vue&type=script&lang=js"
export * from "./IftaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports